import { useState } from "react";
import { useSelector } from "react-redux";
import SendModal from "../SendModal";
import DeleteModal from "../../../common/DeleteModal";
import NotificationService from "../../../../services/NotificationService";
import trashIcon from "../../../../images/icons/delete.svg";
import editIcon from "../../../../images/icons/edit.svg";
import { useNavigate } from "react-router-dom";
import { Translate } from "../../../Enums/Tranlate";
import { usePermissions } from "../../../common/permissions";

const CardItem = ({ item, index, setShouldUpdate }) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const [send, setSend] = useState(false);
	const navigate = useNavigate();
	const Auth = useSelector((state) => state.auth?.auth);
	const lang = useSelector((state) => state.auth?.lang);
	const { canEdit, canDelete } = usePermissions();
	const notificationService = new NotificationService();

	return (
		<tr key={index} className="text-center">
			<td>{lang === "en" ? item.title_en : item.title_ar}</td>
			<td>{lang === "en" ? item.description_en : item.description_ar}</td>
			<td>{Translate[lang][item?.type]}</td>
			<td>
				<div className="d-flex" style={{ gap: "20px" }}>
					{canEdit("notification") && (
						<img
							src={editIcon}
							onClick={() => setSend(true)}
							className="cursor-pointer"
							alt="edit"
							width={24}
						/>
					)}
					{canDelete("notification") && (
						<img
							src={trashIcon}
							onClick={() => setDeleteModal(true)}
							className="cursor-pointer"
							alt="trash"
							width={24}
						/>
					)}
				</div>
			</td>

			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={lang === "en" ? item.title_en : item.title_ar}
					deletedItem={item}
					modelService={notificationService}
					onCloseModal={setDeleteModal}
					setShouldUpdate={setShouldUpdate}
				/>
			)}

			{send && (
				<SendModal modal={send} setModal={() => setSend(false)} item={item} />
			)}
		</tr>
	);
};
export default CardItem;
